export default __webpack_public_path__ + "static/media/32942632-1FB0-430B-8E54-AE055936D77F_1_105_c.bd356a76.jpeg";